var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "dialog-card icon-img_card_entry_bg",
      class: { popIn: _vm.visible },
      style: _vm.style,
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$slots.countryMsg,
              expression: "$slots.countryMsg",
            },
          ],
          staticClass: "country-tip",
        },
        [_vm._t("countryMsg")],
        2
      ),
      _vm.showClose
        ? _c("i", {
            staticClass: "icomoon-common_clos",
            on: { click: _vm.closeDialog },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "header" },
        [
          _vm.title
            ? _c("span", { attrs: { title: _vm.title } }, [
                _vm._v(_vm._s(_vm.title)),
              ])
            : _vm._e(),
          !_vm.title ? _vm._t("header") : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "context" }, [_vm._t("default")], 2),
      _c("div", { staticClass: "footer" }, [_vm._t("footer")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }